import {
	ACCOUNTS,
	KYC_ACCOUNTS,
	BULK_OPERATIONS,
	CONFIGURATION,
	KYC_ADMIN,
	KYC_DISABLE_INFO,
	KYC_HISTORY,
	KYC_REPORT_MODULE,
	KYC_SEARCH_DETAIL,
	MIS,
	KYC_TRACKS,
	MISCELLANEOUS,
	USER_MANAGEMENT,
	UTILITY,
	KYC_UPDATE_REQUEST,
	GENIE,
	BUSINESS_MODULES,
	WALLET_MODULE,
	DRIVE_MODULE,
	PRODUCT_AVAILABILITY_TRACKING,
} from 'Helpers/ats.constants';
import {KycAdminPaths} from 'Router/KYCAdminPaths';
import {Paths} from 'Router/Paths';

export const MenuList = [
	// {
	//   title: "Dashboard",
	//   module_slug: "dashboard",
	//   path: Paths.users,
	//   icon: "dashboard"
	// },
	{
		title: 'Categories',
		module_slug: 'manage_category',
		path: Paths.categoryList,
		icon: 'category',
	},
	{
		title: 'CRM',
		module_slug: ['crm_orders', 'product_category_report', 'cart_products_report'],
		icon: 'CRM',
		subMenu: [
			{
				title: 'Orders',
				module_slug: 'crm_orders',
				path: Paths.crmOrders,
			},
			{
				title: 'Failed Orders',
				module_slug: 'crm_failed_orders',
				path: Paths.crmFailedOrders,
			},
			{
				title: 'Bulk Undelivered Queue',
				module_slug: 'crm_orders',
				path: Paths.crmBulkUndeliveredQueue,
			},
			{
				title: 'HO Order Returns',
				module_slug: 'crm_orders',
				path: Paths.crmOrderReturnSearch,
			},
			{
				title: 'Sales Report',
				module_slug: ['product_category_report', 'cart_products_report'],
				icon: 'salesReport',
				subMenu: [
					{
						title: 'Product Category Report',
						module_slug: 'product_category_report',
						path: Paths.productCategoryReport,
					},
					{
						title: 'Cart Products Report',
						module_slug: 'cart_products_report',
						path: Paths.cartProductsReport,
					},
				],
			},
		],
	},
	{
		title: 'Brand Management',
		module_slug: ['brands', 'brand_template'],
		icon: 'Brands',
		subMenu: [
			{
				title: 'Brands',
				module_slug: 'brands',
				path: Paths.brandList,
			},
			{
				title: 'Brand Templates',
				module_slug: 'brand_template',
				path: Paths.brandTemplateList,
			},
		],
	},

	{
		title: 'Tags',
		module_slug: 'manage_tags',
		path: Paths.tagsList,
		icon: 'tags',
	},
	{
		title: 'Bank Management',
		module_slug: ['manage_bank', 'manage_bank_branches'],
		icon: 'Banks',
		subMenu: [
			{
				title: 'Manage Banks',
				module_slug: 'manage_bank',
				path: Paths.bankList,
			},
			{
				title: 'Manage Branches',
				module_slug: 'manage_bank_branches',
				path: Paths.branchList,
			},
		],
	},
	{
		title: 'Employee',
		module_slug: 'manage_employee',
		path: Paths.employeeList,
		icon: 'employees',
	},
	{
		title: 'Attributes',
		module_slug: 'attributes_list',
		path: Paths.attributesList,
		icon: 'attributes',
	},
	{
		title: 'Attribute Values',
		module_slug: 'variants_list',
		path: Paths.variantsList,
		icon: 'variants',
	},
	{
		title: 'Depot Manager',
		module_slug: ['manage_depots'],
		icon: 'configurations',
		subMenu: [
			{
				title: 'Manage Depots',
				path: Paths.depotList,
				module_slug: 'manage_depots',
			},
		],
	},
	// Product Manager menu grouping products list and update products bulk upload
	{
		title: 'Product Manager',
		module_slug: ['product_list', 'update_products'],
		icon: 'products',
		subMenu: [
			{
				title: 'Products',
				path: Paths.productList,
				module_slug: 'product_list',
			},
			{
				title: 'Update Products',
				path: Paths.updateProducts,
				module_slug: 'update_products',
			},
		],
	},
	{
		title: 'Product Availability Tracking',
		module_slug: PRODUCT_AVAILABILITY_TRACKING,
		path: Paths.productAvailabilityTrackingList,
	},

	// {
	//   title: "Bulk Update PV",
	//   path: Paths.bulkUploadPv,
	//   module_slug: "manage_utility"
	// },

	{
		title: 'Update Price/PV/SP',
		path: Paths.updatePrice,
		module_slug: 'update_price',
	},
	{
		title: 'User Management',
		module_slug: ['manage_user', 'manage_role', 'manage_executive', USER_MANAGEMENT.MANAGE_MODULES],
		icon: 'user',
		subMenu: [
			{
				title: 'Manage Users',
				path: Paths.manageUser,
				module_slug: 'manage_user',
			},
			{
				title: 'Manage Roles',
				path: Paths.manageRole,
				module_slug: 'manage_role',
			},
			{
				title: 'Manage Executives',
				path: Paths.executivesList,
				module_slug: 'manage_executive',
			},
			{
				title: 'Manage Modules',
				path: Paths.manageModules,
				module_slug: USER_MANAGEMENT.MANAGE_MODULES,
			},
		],
	},
	{
		title: 'Manage Ecom User',
		module_slug: ['ecom_user_permission'],
		icon: 'user',
		subMenu: [
			{
				title: 'Block/Unblock User',
				path: Paths.ecomUserPermissionList,
				module_slug: 'ecom_user_permission',
			},
		],
	},
	{
		title: 'Udaan Manager',
		module_slug: ['manage_batch', 'manage_udaan_report'],
		subMenu: [
			{
				title: 'Manage Batches',
				path: Paths.manageBatch,
				module_slug: 'manage_batch',
			},
			{
				title: 'Registration Report',
				path: Paths.udaanReport,
				module_slug: 'manage_udaan_report',
			},
		],
	},
	{
		title: 'Grievance Manager',
		module_slug: 'manage_grievance',
		path: Paths.grievanceList,
		icon: 'comment',
	},
	{
		title: 'Nirjara Dashboard',
		module_slug: 'manage_nirjara',
		path: Paths.nirjaraDashboard,
		icon: 'dashboard',
	},
	{
		title: 'Grand Growth Award',
		module_slug: [
			'grand_growth_award_leaders_manager',
			'grand_growth_award_reports_manager',
			'grand_growth_award_report_assign',
			'grand_growth_award_eligibility',
			'grand_growth_award_level1_check',
			'grand_growth_award_level2_check',
			'grand_growth_award_final_export',
		],
		icon: 'products',
		subMenu: [
			{
				title: 'Leaders Manager',
				path: Paths.grandGrowthAwardLeaders,
				module_slug: 'grand_growth_award_leaders_manager',
			},
			{
				title: 'Reports',
				path: Paths.grandGrowthAwardReports,
				module_slug: 'grand_growth_award_reports_manager',
			},
			{
				title: 'Assign Leader Reports',
				path: Paths.grandGrowthAwardReportAssign,
				module_slug: 'grand_growth_award_report_assign',
			},
			{
				title: 'Eligibility Manager',
				path: Paths.grandGrowthAwardEligibility,
				module_slug: 'grand_growth_award_eligibility',
			},
			{
				title: 'Level 1 Check-in',
				path: Paths.grandGrowthAwardLevel1Check,
				module_slug: 'grand_growth_award_level1_check',
			},
			{
				title: 'Level 2 Check-in',
				path: Paths.grandGrowthAwardLevel2Check,
				module_slug: 'grand_growth_award_level2_check',
			},
			{
				title: 'Growth Celebration Report',
				path: Paths.grandGrowthAwardFinalExport,
				module_slug: 'grand_growth_award_final_export',
			},
		],
	},
	{
		title: 'South Ceremony Event',
		module_slug: ['south_ceremony_event_leaders_manager', 'south_ceremony_event_report_assignments'],
		icon: 'products',
		subMenu: [
			{
				title: 'Leaders Manager',
				path: Paths.southCeremonyEventLeaders,
				module_slug: 'south_ceremony_event_leaders_manager',
			},
			{
				title: 'Report Assignments',
				path: Paths.southCeremonyEventReportAssignments,
				module_slug: 'south_ceremony_event_report_assignments',
			},
		],
	},
	// // Menu list for report
	{
		title: 'Report',
		module_slug: [
			'manage_ulp_quick',
			'swasthya_jagrukta_janch_evam_paramarsh_shivir',
			'manage_ulp_quick_retention_report',
			'ulp_program_report',
			'zonal_program_report',
		],
		subMenu: [
			{
				title: 'ULP Quick',
				path: Paths.ulpQuick,
				module_slug: 'manage_ulp_quick',
			},
			{
				title: 'Swasthya Jagrukta Shivir',
				path: Paths.swasthyaShivir,
				module_slug: 'swasthya_jagrukta_janch_evam_paramarsh_shivir',
			},
			{
				title: 'ULP Quick Retention Report',
				path: Paths.ulpQuickRetentionReport,
				module_slug: 'manage_ulp_quick_retention_report',
			},
			{
				title: 'ULP Program Report',
				path: Paths.ulpProgramReport,
				module_slug: 'ulp_program_report',
			},
			{
				title: 'Zonal Program Report',
				path: Paths.zonalProgramReport,
				module_slug: 'zonal_program_report',
			},
			{
				title: 'Offer Impact Report',
				path: Paths.offerImpactReport,
				module_slug: 'manage_offer_report',
			},
		],
	},
	{
		title: 'Wallet',
		module_slug: [WALLET_MODULE.LIST, WALLET_MODULE.MAPPED, WALLET_MODULE.REMAINING_BALANCE],
		icon: 'wallet',
		subMenu: [
			{
				title: 'All Wallets',
				path: Paths.walletList,
				module_slug: WALLET_MODULE.LIST,
			},
			{
				title: 'Wallets Mapping',
				path: Paths.mappedList,
				module_slug: WALLET_MODULE.MAPPED,
			},
			{
				title: 'Wallet Remaining Balance',
				path: Paths.walletRemainingBalance,
				module_slug: WALLET_MODULE.REMAINING_BALANCE,
			},
		],
	},
	{
		title: 'Offers & Vouchers',
		module_slug: ['offer_list', 'vouchers', 'purchase_rules'],
		icon: 'Offer&Coupon',
		subMenu: [
			// {
			//   title: "Coupons",
			//   path: Paths.couponList,
			//   module_slug: "coupon_list"
			// },
			{
				title: 'Offers',
				path: Paths.offersList,
				module_slug: 'offer_list',
			},
			{
				title: 'Vouchers',
				path: Paths.voucherList,
				module_slug: 'vouchers',
			},
			{
				title: 'Purchase Rules',
				path: Paths.purchaseRulesList,
				module_slug: 'purchase_rules',
			},
		],
	},
	{
		title: 'Custom Shipping',
		module_slug: ['shipping_sequences', 'sequence_mapping'],
		icon: 'cso',
		subMenu: [
			{
				title: 'Shipping Sequences',
				path: Paths.shippingSequencesList,
				module_slug: 'shipping_sequences',
			},
			{
				title: 'Sequence Mapping',
				path: Paths.sequenceMapppingList,
				module_slug: 'sequence_mapping',
			},
		],
	},
	// {
	//   title: "Pincode Store Map",
	//   module_slug: "pincode_store_map",
	//   path: Paths.pincodeMappingList,
	//   icon: "pincodeStore"
	// },

	{
		title: 'Ecom Report',
		module_slug: [
			'manage_aparjita',
			'manage_rupantaran_yatra_delhi',
			'module_special_women_registration',
			'purchaser_in_your_group',
			'display_wall_report',
			'puc_report',
			'your_group',
			'ab_kyc_status',
			'purchase_volume_calculator',
			'product_purchase',
			'last_month_p_v_datewise',
			'tax_invoice',
			'report_view_logs',
			'ab_growth_report',
			'product_price_list',
			'technical_group_structure',
			'internal_report_view_logs',
			'sewa_diwas_pre_event',
			'sewa_diwas_post_event',
			'sewa_diwas_digital_materials',
			'sewa_diwas_reports',
			'sewa_diwas_ratings',
			'sehat_ke_sitaare',
			'sehat_mitra',
		],
		icon: '',
		subMenu: [
			{
				title: 'Aparajita',
				path: Paths.Aparajita,
				module_slug: 'manage_aparjita',
			},
			{
				title: 'Rupantaran Yatra Delhi',
				path: Paths.RupantaranYatraDelhi,
				module_slug: 'manage_rupantaran_yatra_delhi',
			},
			{
				title: 'Special Women Registration',
				path: Paths.specialWomenRegistration,
				module_slug: 'module_special_women_registration',
			},
			{
				title: 'Purchaser In Your Group',
				path: Paths.purchaserInYourGroup,
				module_slug: 'purchaser_in_your_group',
			},
			{
				title: 'Display Wall Report',
				path: Paths.RCMDisplayWallReport,
				module_slug: 'display_wall_report',
			},
			{
				title: 'PUC Report',
				path: Paths.PUCReport,
				module_slug: 'puc_report',
			},
			{
				title: 'Your Group',
				path: Paths.yourGroup,
				module_slug: 'your_group',
			},
			{
				title: 'Product Purchase',
				path: Paths.productPurchase,
				module_slug: 'product_purchase',
			},
			{
				title: 'Product Purchase Monthly',
				path: Paths.productPurchaseMonthly,
				module_slug: 'product_purchase_monthly',
			},
			{
				title: 'Purchase Volume Calculator',
				path: Paths.purchaseVolumeCalculator,
				module_slug: 'purchase_volume_calculator',
			},
			{
				title: 'Last Month P.V. Datewise',
				path: Paths.lastMonthPVDatewise,
				module_slug: 'last_month_pv_datewise',
			},
			{
				title: 'AB KYC Status',
				path: Paths.ABKycStatus,
				module_slug: 'ab_kyc_status',
			},
			{
				title: 'GST Invoice',
				path: Paths.gstInvoice,
				module_slug: 'tax_invoice',
			},
			{
				title: 'AB Growth Report',
				path: Paths.abGrowthReport,
				module_slug: 'ab_growth_report',
			},
			{
				title: 'Report View Logs',
				path: Paths.reportViewLogs,
				module_slug: 'report_view_logs',
			},
			{
				title: 'Internal Report View Logs',
				path: Paths.internalReportViewLogs,
				module_slug: 'internal_report_view_logs',
			},
			{
				title: 'Monthly Statement',
				path: Paths.monthlyStatement,
				module_slug: 'monthly_statement',
			},
			{
				title: 'Product Price List',
				path: Paths.productPriceList,
				module_slug: 'product_price_list',
			},
			{
				title: 'Technical / Royalty Tree View',
				path: Paths.technicalGroupStructure,
				module_slug: 'technical_group_structure',
			},
			{
				title: 'Mashal Report',
				path: Paths.mashalReport,
				module_slug: 'mashal_report',
			},
			{
				title: 'Sehat ke Sitare',
				path: Paths.sehatKeSitaare,
				module_slug: 'sehat_ke_sitaare',
			},
			{
				title: 'Sewa Diwas',
				module_slug: [
					'sewa_diwas_pre_event',
					'sewa_diwas_post_event',
					'sewa_diwas_digital_materials',
					'sewa_diwas_reports',
					'sewa_diwas_ratings',
				],
				icon: 'sewa-diwas',
				subMenu: [
					{
						title: 'Pre Event Registrations',
						path: Paths.sewaDiwasPreEvents,
						module_slug: 'sewa_diwas_pre_event',
					},
					{
						title: 'Post Event Registrations',
						path: Paths.sewaDiwasPostEvents,
						module_slug: 'sewa_diwas_post_event',
					},
					{
						title: 'Digital Materials Management',
						path: Paths.sewaDiwasDigitalMaterials,
						module_slug: 'sewa_diwas_digital_materials',
					},
					{
						title: 'Reports & Exports',
						path: Paths.sewaDiwasReports,
						module_slug: 'sewa_diwas_reports',
					},
					{
						title: 'Event Rating Management',
						path: Paths.sewaDiwasRatings,
						module_slug: 'sewa_diwas_ratings',
					},
				],
			},
			{
				title: 'Sehat Mitra',
				path: Paths.sehatMitra,
				module_slug: 'sehat_mitra',
			},
		],
	},
	{
		title: 'Call Center Reports',
		module_slug: [
			'manage_user_details',
			'manage_plantations',
			'manage_blood_donors',
			'consistency_dashboard',
			'store_feedback',
			'post_purchase_feedback',
			'new_joiner_feedback',
		],
		icon: '',
		subMenu: [
			{
				title: 'User Details',
				path: Paths.UserDetails,
				module_slug: 'manage_user_details',
			},
			{
				title: 'Plantations',
				path: Paths.Plantations,
				module_slug: 'manage_plantations',
			},
			{
				title: 'Blood Donors',
				path: Paths.BloodDonors,
				module_slug: 'manage_blood_donors',
			},
			{
				title: 'Consistency Dashboard',
				path: Paths.ConsistencyDashboard,
				module_slug: 'consistency_dashboard',
			},
			{
				title: 'Store Feedback',
				path: Paths.storeFeedback,
				module_slug: 'store_feedback',
			},
			{
				title: 'Post Purchase Feedback',
				path: Paths.postPurchaseFeedback,
				module_slug: 'post_purchase_feedback',
			},
			{
				title: 'New Joiner Feedback',
				path: Paths.newJoinerFeedback,
				module_slug: 'new_joiner_feedback',
			},
		],
	},

	{
		title: 'Store Map',
		module_slug: ['pincode_store_map', 'pincode_area_map', 'pincode_listing', 'pincode_store_map_schedule'],
		icon: 'pincodeStore',
		subMenu: [
			{
				title: 'Pincode Area Map',
				path: Paths.pincodeAreaMappingList,
				module_slug: 'pincode_area_map',
			},
			{
				title: 'Pincode Store Map',
				module_slug: 'pincode_store_map',
				path: Paths.pincodeMappingList,
				icon: 'pincodeStore',
			},
			{
				title: 'Pincode Store Map Schedule',
				module_slug: 'pincode_store_map_schedule',
				path: Paths.pincodeScheduleList,
			},
			{
				title: 'Pincode Listing',
				module_slug: 'pincode_listing',
				path: Paths.pincodeListing,
			},
		],
	},
	{
		title: 'Shipping Charges',
		module_slug: 'shipping_charges',
		path: Paths.shippingChargesList,
		icon: 'shippingPrice',
	},

	{
		title: 'Configurations',
		module_slug: [
			CONFIGURATION.SETTING,
			CONFIGURATION.MDM_SETTING,
			CONFIGURATION.MODULE_REMARK_MASTER,
			CONFIGURATION.MODULE_REMARK_MODULE_MASTER,
			'user_activity_logs',
		],
		icon: 'configurations',
		subMenu: [
			{
				title: 'Settings',
				path: Paths.settingsList,
				module_slug: CONFIGURATION.SETTING,
			},
			{
				title: 'User Activity Logs',
				path: Paths.userActivityLogs,
				module_slug: 'user_activity_logs',
			},
			{
				title: 'MDM Settings',
				path: Paths.mdmSettingsList,
				module_slug: CONFIGURATION.MDM_SETTING,
			},
			{
				title: 'Remarks Master',
				path: Paths.remarksMaster,
				module_slug: CONFIGURATION.MODULE_REMARK_MASTER,
			},
			{
				title: 'Remark Module Names',
				path: Paths.remarkModulesMaster,
				module_slug: CONFIGURATION.MODULE_REMARK_MODULE_MASTER,
			},
		],
	},
	{
		title: 'Notification Management',
		module_slug: [
			'notification_list',
			'notification_category_list',
			'send_notification_list',
			'targeted_notification_list',
			'ab_scheduled_messages_list',
			'targeted_voice_broadcast',
		],
		icon: 'manageNotification',
		subMenu: [
			{
				title: 'Notification Category',
				path: Paths.notificationCategoryList,
				module_slug: 'notification_category_list',
			},
			{
				title: 'Notifications',
				path: Paths.notificationList,
				module_slug: 'notification_list',
			},
			{
				title: 'Send Notification',
				path: Paths.sendNotificationList,
				module_slug: 'send_notification_list',
			},
			{
				title: 'SMS/Whatsapp Templates',
				path: Paths.notificationTemplateList,
				module_slug: 'targeted_notification_list',
			},
			{
				title: 'Targeted Notification',
				path: Paths.targetedNotificationList,
				module_slug: 'targeted_notification_list',
			},
			{
				title: 'AB Scheduled Messages',
				path: Paths.abScheduledMessagesList,
				module_slug: 'ab_scheduled_messages_list',
			},
			{
				title: 'Voice Broadcast System',
				path: Paths.voiceBroadcastList,
				module_slug: 'targeted_voice_broadcast',
			},
		],
	},
	{
		title: 'Website',
		module_slug: [
			'featured_category',
			'menu_management',
			'ecom_profile_modules_management',
			'ab_message',
			'product_sections',
			'downloads',
			'media_category',
			'media_content',
			'banner_list',
			'cache_manager',
		],
		icon: 'website',
		subMenu: [
			{
				title: 'Manage Media',
				module_slug: ['media_category', 'media_content'],
				icon: 'manageMedia',
				subMenu: [
					{
						title: 'Media Categories',
						path: Paths.mediaCategory,
						module_slug: 'media_category',
					},
					{
						title: 'Media Content',
						path: Paths.mediaContentList,
						module_slug: 'media_content',
					},
				],
			},
			{
				title: 'Downloads',
				module_slug: ['downloads', 'download_category', 'content_type', 'download_language'],
				icon: 'manageMedia',
				subMenu: [
					{
						title: 'Download Category',
						path: Paths.downloadCategoryList,
						module_slug: 'download_category',
					},
					{
						title: 'Download Language',
						path: Paths.downloadLanguageList,
						module_slug: 'download_language',
					},
					{
						title: 'Content Type',
						path: Paths.contentTypeList,
						module_slug: 'content_type',
					},
					{
						title: 'Download Content',
						module_slug: 'downloads',
						path: Paths.downloadList,
					},
				],
			},
			{
				title: 'Static Pages',
				module_slug: ['rcm_events', 'meetings_schedule', 'general_page', 'about_us_history', 'notice'],
				icon: 'manageMedia',
				subMenu: [
					// {
					//   title: "Meetings Schedule",
					//   path: Paths.meetingsList,
					//   module_slug: "meetings_schedule"
					// },
					{
						title: 'General Pages',
						path: Paths.generalPagesList,
						module_slug: 'general_page',
					},
					{
						title: 'About Us - History',
						path: Paths.aboutUsHistoryList,
						module_slug: 'about_us_history',
					},
					{
						title: 'Contact Us',
						module_slug: 'ecom_contact_us',
						path: Paths.ecomContactList,
						icon: 'contact_us',
					},
				],
			},
			{
				title: 'ULP Manager',
				module_slug: ['rcm_events'],
				icon: 'manageMedia',
				subMenu: [
					// {
					//   title: "Meetings Schedule",
					//   path: Paths.meetingsList,
					//   module_slug: "meetings_schedule"
					// },
					{
						title: 'RCM Events',
						path: Paths.eventsList,
						module_slug: 'rcm_events',
					},
					{
						title: 'ULP Target',
						path: Paths.ulpTarget,
						module_slug: 'rcm_events',
					},
				],
			},
			{
				title: 'Language',
				path: Paths.marketingPlanLanguageList,
				module_slug: 'marketing_plan_language',
			},
			// {
			//   title: "Marketing Plan",
			//   path: Paths.marketingPlanList,
			//   module_slug: "marketing_plan"
			// },
			{
				title: 'Cache Manager',
				path: Paths.cacheManager,
				module_slug: 'cache_manager',
			},
			{
				title: 'Banner Management',
				path: Paths.bannerList,
				module_slug: 'banner_list',
			},
			{
				title: 'Products Section',
				module_slug: 'product_sections',
				path: Paths.productSectionsList,
				icon: 'productsSection',
			},
			{
				title: 'Featured Category',
				module_slug: 'featured_category',
				path: Paths.featuredCategory,
				icon: 'featuredCategory',
			},
			{
				title: 'Header Menu Management',
				module_slug: 'menu_management',
				path: Paths.manageMenuList,
				icon: 'menuManagement',
			},
			{
				title: 'Profile Menu Management',
				module_slug: 'ecom_profile_modules_management',
				path: Paths.manageProfileMenuList,
				icon: 'menuManagement',
			},
			{
				title: 'AB Message',
				module_slug: 'ab_message',
				path: Paths.abMessageList,
				icon: 'abMessage',
			},
			{
				title: 'Compliance Documents',
				module_slug: 'compliance_documents',
				path: Paths.complianceDocumentsList,
				icon: 'abMessage',
			},
			{
				title: 'Faqs',
				module_slug: 'faqs',
				path: Paths.faqsList,
				icon: 'faqs',
			},
			{
				title: 'Size Chart',
				module_slug: 'size_chart',
				path: Paths.sizeChartList,
				icon: 'abMessage',
			},

			{
				title: 'Ecom Notifications',
				path: Paths.noticesList,
				module_slug: 'notice',
			},

			// {
			//   title: "Downloads",
			//   module_slug: "downloads",
			//   path: Paths.downloadList,
			//   icon: "downloads"
			// }
		],
	},
	{
		title: 'KYC Admin',
		module_slug: [
			KYC_ADMIN.UPDATE_GST,
			KYC_ADMIN.KYC_REPORTS_VIEW_LOGS,
			KYC_ADMIN.INCREASE_MOBILE_COUNT,
			KYC_ADMIN.EXCEPTIONAL_CASES,
			KYC_ADMIN.MASTERS,
			KYC_ADMIN.MASTER_PIN_DESCRIPTION,
			KYC_ADMIN.MASTER_DOCUMENTS,
			KYC_ADMIN.MASTER_OCCUPATIONS,
			KYC_ADMIN.MASTER_RELATIONS,
			KYC_ADMIN.MASTER_DIAMOND_CLUB,
			KYC_ADMIN.MASTER_COMPANY_LIST,
			KYC_ADMIN.MASTER_KYC_REASON_DESC,
			KYC_ADMIN.MASTER_DEPARTMENT_LIST,
		],
		icon: '',
		subMenu: [
			{
				title: 'Update GST',
				module_slug: KYC_ADMIN.UPDATE_GST,
				path: KycAdminPaths.gst,
			},
			{
				title: 'AB Unstop',
				module_slug: KYC_ADMIN.AB_UNSTOP,
				path: Paths.abUnstop,
			},
			{
				title: 'KYC Reports View Logs',
				module_slug: KYC_ADMIN.KYC_REPORTS_VIEW_LOGS,
				path: Paths.kycReportsViewLogs,
			},
			{
				title: 'Increase Mobile Count',
				module_slug: KYC_ADMIN.INCREASE_MOBILE_COUNT,
				path: Paths.increaseMobileCount,
			},
			{
				title: 'Exceptional Cases',
				module_slug: KYC_ADMIN.EXCEPTIONAL_CASES,
				path: KycAdminPaths.exceptionalCases,
			},
			{
				title: 'Masters',
				module_slug: [
					KYC_ADMIN.MASTERS,
					KYC_ADMIN.MASTER_PIN_DESCRIPTION,
					KYC_ADMIN.MASTER_DOCUMENTS,
					KYC_ADMIN.MASTER_OCCUPATIONS,
					KYC_ADMIN.MASTER_RELATIONS,
					KYC_ADMIN.MASTER_DIAMOND_CLUB,
					KYC_ADMIN.MASTER_COMPANY_LIST,
					KYC_ADMIN.MASTER_KYC_REASON_DESC,
					KYC_ADMIN.MASTER_DEPARTMENT_LIST,
				],
				icon: 'kyc-admin',
				subMenu: [
					{
						title: 'Master Pin Description',
						module_slug: KYC_ADMIN.MASTER_PIN_DESCRIPTION,
						path: KycAdminPaths.masterPinDescription,
					},
					{
						title: 'Master Documents',
						module_slug: KYC_ADMIN.MASTER_DOCUMENTS,
						path: KycAdminPaths.masterDocuments,
					},
					{
						title: 'Master Occupations',
						module_slug: KYC_ADMIN.MASTER_OCCUPATIONS,
						path: KycAdminPaths.masterOccupations,
					},
					{
						title: 'Master Relations',
						module_slug: KYC_ADMIN.MASTER_RELATIONS,
						path: KycAdminPaths.masterRelations,
					},
					{
						title: 'Master Diamond Club',
						module_slug: KYC_ADMIN.MASTER_DIAMOND_CLUB,
						path: KycAdminPaths.masterDiamondClub,
					},
					{
						title: 'Master Company List',
						module_slug: KYC_ADMIN.MASTER_COMPANY_LIST,
						path: KycAdminPaths.masterCompanyList,
					},
					{
						title: 'Master Kyc Reason Desc',
						module_slug: KYC_ADMIN.MASTER_KYC_REASON_DESC,
						path: KycAdminPaths.masterKycReasonDesc,
					},
					{
						title: 'Master Department List',
						module_slug: KYC_ADMIN.MASTER_DEPARTMENT_LIST,
						path: KycAdminPaths.masterDepartmentList,
					},
				],
			},
		],
	},
	{
		title: 'KYC Modules',
		module_slug: [
			'kyc_search_ab_bank',
			'kyc_search_ab_mobile',
			'kyc_search_ab_aadhar',
			'kyc_search_ab_pan',
			'kyc_search_ab_state_name',
			'kyc_search_ab_reference',
			'kyc_delete_bank_acc',
			'kyc_delete_pan_details',
			'kyc_enable_refill_kyc',
			'kyc_report_detail_report',
			'kyc_report_not_ok_report',
			'kyc_reports_declaration_report',
			'kyc_report_current_business_report',
			'kyc_report_feeded_user_wise',
			'kyc_report_executive_feedback_report',
			'kyc_report_self_pv_report',
			'kyc_report_amount_wise_ab_count',
			'ekyc_list_for_checking',
			'kyc_list_terminate_repurchase',
			'kyc_list_monthly_meetings_report',
			'kyc_list_technical_leader_tree',
			'kyc_list_technical_core_list',
			'kyc_associate_buyer_ab_id_stop',
			'kyc_associate_buyer_reset_pass',
			'kyc_associate_buyer_ab_details',
			'kyc_associate_buyer_uptree',
			'kyc_associate_buyer_sms_diamond_club',
			'kyc_associate_buyer_purchase_download',
			'kyc_associate_buyer_not_purchase_otp',
			'kyc_declaration_mobile_num',
			'kyc_declaration_info_update',
			'similar_kyc_entries',
			'kyc_new_entry',
			'kyc_old_entry',
			'kyc_terminate_ab',
			'kyc_remove_termination_of_ab',
			'kyc_update_request_bank',
			'kyc_update_request_pan',
			'kyc_document_update_address_id',
			'kyc_document_update_pan',
			'kyc_document_update_ab_photo',
			'verification',
			'kyc_report_death_case_report',
			'kyc_report_stop_ab_report',
			'kyc_report_terminate_ab',
			'kyc_report_non_purchasing_ab_report',
			'kyc_report_pin_achiever_report',
			'kyc_report_pin_dashboard',
			'kyc_report_ab_last_6_month_report',
			'kyc_associate_buyer_name_update',
			'kyc_associate_buyer_payment',
			'kyc_associate_buyer_repurchase',
			'kyc_associate_buyer_monthly_meetings',
			'kyc_document_update_ab_bank',
			'kyc_death_case',
			'kyc_report_diamond_club_purchase',
			KYC_ACCOUNTS.PAYMENT_ENTRY,
			KYC_ACCOUNTS.BUSINESS_ENTRY,
			KYC_ACCOUNTS.JV_ENTRY,
		],
		icon: 'kyc-admin',
		subMenu: [
			{
				title: 'Search Details',
				module_slug: [
					KYC_SEARCH_DETAIL.BANK_ACC_NO,
					KYC_SEARCH_DETAIL.REG_MOBILE_NO,
					KYC_SEARCH_DETAIL.AADHAR_NO,
					KYC_SEARCH_DETAIL.PAN_NO,
					KYC_SEARCH_DETAIL.STATE_NAME,
					KYC_SEARCH_DETAIL.REFERENCE_NO,
					KYC_SEARCH_DETAIL.EMAIL_ID,
				],
				icon: 'manageMedia',
				subMenu: [
					{
						title: 'Aadhar Number',
						path: KycAdminPaths.searchByAadharNo,
						module_slug: KYC_SEARCH_DETAIL.AADHAR_NO,
					},
					{
						title: 'Associate Buyer Name',
						path: KycAdminPaths.stateWiseSearchAbName,
						module_slug: KYC_SEARCH_DETAIL.STATE_NAME,
					},
					{
						title: 'Bank Account Number',
						path: KycAdminPaths.searchByBankAccountNumber,
						module_slug: KYC_SEARCH_DETAIL.BANK_ACC_NO,
					},
					{
						title: 'Display Wall',
						path: KycAdminPaths.displayWall,
						module_slug: KYC_SEARCH_DETAIL.AB_DW_ASSOCIATION,
					},
					{
						title: 'Email Id',
						path: KycAdminPaths.searchByEmailId,
						module_slug: KYC_SEARCH_DETAIL.EMAIL_ID,
					},
					{
						title: 'PAN Number',
						path: KycAdminPaths.searchByPanNo,
						module_slug: KYC_SEARCH_DETAIL.PAN_NO,
					},
					{
						title: 'Reference Number',
						path: KycAdminPaths.referenceNumber,
						module_slug: KYC_SEARCH_DETAIL.REFERENCE_NO,
					},
					{
						title: 'Registered Mobile Number',
						path: KycAdminPaths.searchByRegisteredMobileNo,
						module_slug: KYC_SEARCH_DETAIL.REG_MOBILE_NO,
					},
				],
			},
			{
				title: 'Enable Info',
				module_slug: ['kyc_delete_bank_acc', 'kyc_delete_pan_details', 'kyc_enable_refill_kyc'],
				icon: 'enableInfo',
				subMenu: [
					{
						title: 'Bank Account Details',
						path: KycAdminPaths.deleteBankAccountDetails,
						module_slug: 'kyc_delete_bank_acc',
					},
					{
						title: 'PAN Number',
						path: KycAdminPaths.deletePanNumber,
						module_slug: 'kyc_delete_pan_details',
					},
					{
						title: 'Re-KYC (For Existing AB) ',
						path: KycAdminPaths.enableReKYC,
						module_slug: 'kyc_enable_refill_kyc',
					},
				],
			},
			{
				title: 'Disable Info',
				module_slug: [KYC_DISABLE_INFO.BANK_ACC_NO, KYC_DISABLE_INFO.PAN_NO],
				icon: 'disableInfo',
				subMenu: [
					{
						title: 'Bank Account',
						path: KycAdminPaths.disableBankNo,
						module_slug: KYC_DISABLE_INFO.BANK_ACC_NO,
					},
					{
						title: 'PAN Number',
						path: KycAdminPaths.disablePanNo,
						module_slug: KYC_DISABLE_INFO.PAN_NO,
					},
				],
			},
			{
				title: 'Reports',
				module_slug: [
					KYC_REPORT_MODULE.DETAIL_REPORT,
					KYC_REPORT_MODULE.NOT_OK_REPORT,
					KYC_REPORT_MODULE.DECLARATION_REPORT,
					KYC_REPORT_MODULE.FEEDED_USER_WISE,
					KYC_REPORT_MODULE.TERMINATE_AB,
					KYC_REPORT_MODULE.NON_PURCHASING_AB_REPORT,
					KYC_REPORT_MODULE.AMOUNT_WISE_AB_COUNT,
					KYC_REPORT_MODULE.SELF_PV_REPORT,
					KYC_REPORT_MODULE.LIST_TERMINATE_REPURCHASE,
					KYC_REPORT_MODULE.DEATH_CASE_REPORT,
					KYC_REPORT_MODULE.STOP_AB_REPORT,
					KYC_REPORT_MODULE.PIN_ACHIEVER_REPORT,
					KYC_REPORT_MODULE.PIN_DASHBOARD,
					KYC_REPORT_MODULE.AB_LAST_6_MONTH_REPORT,
					KYC_REPORT_MODULE.DIAMOND_CLUB_PURCHASE,
					KYC_REPORT_MODULE.STOP_TERMINATION,
					KYC_REPORT_MODULE.RED_KYC,
					KYC_REPORT_MODULE.KYC_AB_BULK_DETAILS,
					KYC_REPORT_MODULE.PIN_GROWTH_ANALYSIS,
					KYC_REPORT_MODULE.KYC_AB_COMMISSION,
					KYC_REPORT_MODULE.UNETHICAL_JOINING_STOP,
				],
				icon: 'reports',
				subMenu: [
					{
						title: 'Declaration Report',
						path: KycAdminPaths.declareReport,
						module_slug: KYC_REPORT_MODULE.DECLARATION_REPORT,
					},
					{
						title: 'KYC Detail Report',
						path: KycAdminPaths.kycDetailReport,
						module_slug: KYC_REPORT_MODULE.DETAIL_REPORT,
					},
					{
						title: 'KYC Not OK Report',
						path: KycAdminPaths.kycNotOk,
						module_slug: KYC_REPORT_MODULE.NOT_OK_REPORT,
					},
					{
						title: 'KYC Feeding Userwise',
						path: KycAdminPaths.kycFeedingReport,
						module_slug: KYC_REPORT_MODULE.FEEDED_USER_WISE,
					},
					{
						title: 'Non Purchasing AB',
						path: KycAdminPaths.nonPurchasingABReport,
						module_slug: KYC_REPORT_MODULE.NON_PURCHASING_AB_REPORT,
					},
					{
						title: 'Terminate Repurchase',
						path: KycAdminPaths.terminateRepurchaseReport,
						module_slug: KYC_REPORT_MODULE.LIST_TERMINATE_REPURCHASE,
					},
					{
						title: 'Self P.V. Report',
						path: KycAdminPaths.selfPVReport,
						module_slug: KYC_REPORT_MODULE.SELF_PV_REPORT,
					},
					{
						title: 'Amount Wise AB Count',
						path: KycAdminPaths.amountWiseABCountReport,
						module_slug: KYC_REPORT_MODULE.AMOUNT_WISE_AB_COUNT,
					},
					{
						title: 'Death Case Report',
						path: KycAdminPaths.deathCaseReport,
						module_slug: KYC_REPORT_MODULE.DEATH_CASE_REPORT,
					},
					{
						title: 'Stopped AB Report',
						path: KycAdminPaths.stopABReport,
						module_slug: KYC_REPORT_MODULE.STOP_AB_REPORT,
					},
					{
						title: 'All Termination Report',
						path: KycAdminPaths.allTermination,
						module_slug: KYC_REPORT_MODULE.TERMINATE_AB,
					},
					{
						title: 'Pin Achiever Report',
						path: KycAdminPaths.pinAchieverReport,
						module_slug: KYC_REPORT_MODULE.PIN_ACHIEVER_REPORT,
					},
					{
						title: 'Pin Dashboard',
						path: KycAdminPaths.pinDashboard,
						module_slug: KYC_REPORT_MODULE.PIN_DASHBOARD,
					},
					{
						title: 'AB Last 6 Month Report',
						path: KycAdminPaths.abLastSixMonthsPurchaseReport,
						module_slug: KYC_REPORT_MODULE.AB_LAST_6_MONTH_REPORT,
					},
					{
						title: 'Diamond Club Purchase Report',
						path: KycAdminPaths.diamondClubPurchaseReport,
						module_slug: KYC_REPORT_MODULE.DIAMOND_CLUB_PURCHASE,
					},
					{
						title: 'Stop Termination Report',
						path: KycAdminPaths.stopTerminationReport,
						module_slug: KYC_REPORT_MODULE.STOP_TERMINATION,
					},
					{
						title: 'Red Kyc Report',
						path: KycAdminPaths.redKycs,
						module_slug: KYC_REPORT_MODULE.RED_KYC,
					},
					{
						title: 'AB Bulk Details',
						path: KycAdminPaths.abBulkDetailsReport,
						module_slug: KYC_REPORT_MODULE.KYC_AB_BULK_DETAILS,
					},
					{
						title: 'Pin Growth Analysis',
						path: KycAdminPaths.pinGrowthAnalysis,
						module_slug: KYC_REPORT_MODULE.PIN_GROWTH_ANALYSIS,
					},
					{
						title: 'AB Commission',
						path: KycAdminPaths.abCommission,
						module_slug: KYC_REPORT_MODULE.KYC_AB_COMMISSION,
					},
					{
						title: 'Unethical Joining Stop',
						path: KycAdminPaths.unethicalJoiningStop,
						module_slug: KYC_REPORT_MODULE.UNETHICAL_JOINING_STOP,
					},
				],
			},
			{
				title: 'Lists',
				module_slug: [
					'ekyc_list_for_checking',
					'kyc_list_monthly_meetings_report',
					'kyc_list_technical_leader_tree',
					'kyc_list_technical_core_list',
				],

				icon: 'list',
				subMenu: [
					{
						title: 'E-KYC',
						path: KycAdminPaths.eKyc,
						module_slug: 'ekyc_list_for_checking',
					},
					{
						title: 'Download Monthly Meetings',
						path: KycAdminPaths.monthlyMeetings,
						module_slug: 'kyc_list_monthly_meetings_report',
					},
					{
						title: 'Technical Leader Tree View',
						path: KycAdminPaths.technicalLeaderTreeView,
						module_slug: 'kyc_list_technical_leader_tree',
					},
					{
						title: 'Technical Core List',
						path: KycAdminPaths.technicalCore,
						module_slug: 'kyc_list_technical_core_list',
					},
				],
			},
			{
				title: 'Associate Buyers',
				module_slug: [
					'kyc_report_current_business_report',
					'kyc_associate_buyer_ab_id_stop',
					'kyc_associate_buyer_reset_pass',
					'kyc_associate_buyer_ab_details',
					'kyc_associate_buyer_uptree',
					'kyc_associate_buyer_sms_diamond_club',
					'kyc_associate_buyer_purchase_download',
					'kyc_associate_buyer_not_purchase_otp',
					'kyc_associate_buyer_name_update',
					'kyc_associate_buyer_payment',
					'kyc_associate_buyer_repurchase',
					'kyc_associate_buyer_monthly_meetings',
					'kyc_document_update_ab_bank',
					'kyc_death_case',
					KYC_ADMIN.UPDATE_MOBILE_COUNT,
				],
				icon: 'user',
				subMenu: [
					{
						title: 'Current Business',
						path: KycAdminPaths.currentBusiness,
						module_slug: 'kyc_report_current_business_report',
					},
					{
						title: 'AB ID Stop',
						path: KycAdminPaths.abIdStop,
						module_slug: 'kyc_associate_buyer_ab_id_stop',
					},
					{
						title: 'AB Not Purchase OTP',
						path: KycAdminPaths.abNotPurchaseOtp,
						module_slug: 'kyc_associate_buyer_not_purchase_otp',
					},
					{
						title: 'AB Purchase Download',
						path: KycAdminPaths.abPurchaseDownload,
						module_slug: 'kyc_associate_buyer_purchase_download',
					},
					{
						title: 'AB Password Reset',
						path: KycAdminPaths.resetpswrd,
						module_slug: 'kyc_associate_buyer_reset_pass',
					},
					{
						title: 'AB Stop Payment',
						path: KycAdminPaths.stopPayment,
						module_slug: 'kyc_associate_buyer_payment',
					},
					// {
					//   title: "SMS Diamond Club",
					//   path: KycAdminPaths.smsDiamondClub,
					//   module_slug: "kyc_associate_buyer_sms_diamond_club"
					// },
					// {
					//   title: "AB Check Monthly Meetings",
					//   path: KycAdminPaths.checkMonthlyMeeting,
					//   module_slug: "kyc_associate_buyer_monthly_meetings"
					// },
					{
						title: 'AB Repurchase',
						path: KycAdminPaths.rePurchase,
						module_slug: 'kyc_associate_buyer_repurchase',
					},
					{
						title: 'AB Uptree',
						path: KycAdminPaths.abUptree,
						module_slug: 'kyc_associate_buyer_uptree',
					},
					{
						title: 'AB Details',
						path: KycAdminPaths.abDetails,
						module_slug: 'kyc_associate_buyer_ab_details',
					},
					// {
					//   title: "AB Bank Account Update",
					//   path: KycAdminPaths.abBankAccntUpdate,
					//   module_slug: "kyc_document_update_ab_bank"
					// },
					{
						title: 'AB Name Update',
						path: KycAdminPaths.abNameUpdate,
						module_slug: 'kyc_associate_buyer_name_update',
					},
					{
						title: 'Death Case/Id Transfer',
						path: KycAdminPaths.deathCase,
						module_slug: 'kyc_death_case',
					},
					{
						title: 'Mobile Count Update',
						path: KycAdminPaths.updateMobileCount,
						module_slug: KYC_ADMIN.UPDATE_MOBILE_COUNT,
					},
				],
			},
			{
				title: 'Declaration',
				module_slug: ['kyc_declaration_mobile_num', 'kyc_declaration_info_update'],
				icon: 'declaration',
				subMenu: [
					{
						title: 'Mobile Declaration',
						path: KycAdminPaths.mobileDeclaration,
						module_slug: 'kyc_declaration_mobile_num',
					},
					{
						title: 'Info Update',
						path: KycAdminPaths.infoUpdate,
						module_slug: 'kyc_declaration_info_update',
					},
				],
			},
			{
				title: 'KYC',
				module_slug: [
					'similar_kyc_entries',
					'kyc_new_entry',
					'kyc_old_entry',
					'verification',
					'kyc_report_executive_feedback_report',
				],
				icon: 'kyc-icon',
				subMenu: [
					{
						title: 'KYC Similar Entities',
						path: KycAdminPaths.kycSimilarEntities,
						module_slug: 'similar_kyc_entries',
					},
					{
						title: 'KYC New Entry',
						path: KycAdminPaths.kycNewEntry,
						module_slug: 'kyc_new_entry',
					},
					{
						title: 'KYC Old Entry',
						path: KycAdminPaths.kycOldEntry,
						module_slug: 'kyc_old_entry',
					},
					{
						title: 'Verification',
						path: KycAdminPaths.kycVerification,
						module_slug: 'verification',
					},
					{
						title: 'Instant Approval',
						path: KycAdminPaths.kycInstantApproval,
						module_slug: 'kyc_instant_approval',
					},
					{
						title: 'Executive Feedback',
						path: KycAdminPaths.executiveFeedback_Report,
						module_slug: 'kyc_report_executive_feedback_report',
					},
					{
						title: 'KYC Matching Entities',
						path: KycAdminPaths.kycMatchingEntities,
						module_slug: 'matching_kyc_entities',
					},
				],
			},
			{
				title: 'Terminate-Restore',
				module_slug: ['kyc_terminate_ab'],
				subMenu: [
					{
						title: 'Terminate-Restore AB',
						path: KycAdminPaths.terminateAB,
						module_slug: 'kyc_terminate_ab',
					},
				],
			},
			{
				title: 'Update Request',
				module_slug: [KYC_UPDATE_REQUEST.BANK, KYC_UPDATE_REQUEST.PAN, KYC_UPDATE_REQUEST.MOBILE],
				icon: 'updateRequest',
				subMenu: [
					{
						title: 'Bank Update Request',
						path: KycAdminPaths.bankUpdateRequest,
						module_slug: KYC_UPDATE_REQUEST.BANK,
					},
					{
						title: 'PAN Update Request',
						path: KycAdminPaths.panUpdateRequest,
						module_slug: KYC_UPDATE_REQUEST.PAN,
					},
					{
						title: 'Mobile Update Request',
						path: KycAdminPaths.mobileUpdateRequest,
						module_slug: KYC_UPDATE_REQUEST.MOBILE,
					},
				],
			},
			{
				title: 'Document Update',
				module_slug: [
					'kyc_document_update_address_id',
					'kyc_document_update_pan',
					'kyc_document_update_ab_photo',
				],
				icon: 'doumentUpdate',
				subMenu: [
					{
						title: 'Address & ID Proof',
						path: KycAdminPaths.address_id_proof_update,
						module_slug: 'kyc_document_update_address_id',
					},
					// {
					//   title: "PAN Detail",
					//   path: KycAdminPaths.addPan,
					//   module_slug: "kyc_document_update_pan"
					// },
					{
						title: 'AB Photo Update',
						path: KycAdminPaths.abPhotoUpdate,
						module_slug: 'kyc_document_update_ab_photo',
					},
				],
			},
			{
				title: 'Miscellaneous',
				module_slug: [
					MISCELLANEOUS.KYC_REGISTERED_BUYER,
					MISCELLANEOUS.KYC_NORMAL_BUYER,
					MISCELLANEOUS.KYC_DUPLICATE_RECORD,
					MISCELLANEOUS.RB_REPURCHASE,
					MISCELLANEOUS.NB_REPURCHASE,
					MISCELLANEOUS.AB_SPONSOR_ALLOW_MISUSE,
					MISCELLANEOUS.INACTIVE_REGISTERED_BUYER,
				],
				icon: 'miscellaneous',
				subMenu: [
					{
						title: 'Registered Buyer',
						path: Paths.registeredBuyer,
						module_slug: MISCELLANEOUS.KYC_REGISTERED_BUYER,
					},
					{
						title: 'Normal Buyer',
						path: Paths.normalBuyer,
						module_slug: MISCELLANEOUS.KYC_NORMAL_BUYER,
					},
					{
						title: 'Duplicate Record',
						path: Paths.duplicateRecord,
						module_slug: MISCELLANEOUS.KYC_DUPLICATE_RECORD,
					},
					{
						title: 'RB Repurchase',
						path: KycAdminPaths.rbRepurchase,
						module_slug: MISCELLANEOUS.RB_REPURCHASE,
					},
					{
						title: 'NB Repurchase',
						path: KycAdminPaths.nbRepurchase,
						module_slug: MISCELLANEOUS.NB_REPURCHASE,
					},
					{
						title: 'AB Sponsor Allow Misuse',
						path: Paths.abSponsorAllowMisuse,
						module_slug: MISCELLANEOUS.AB_SPONSOR_ALLOW_MISUSE,
					},
					{
						title: 'Inactive Registered Buyers',
						path: KycAdminPaths.inactiveRegisteredBuyer,
						module_slug: MISCELLANEOUS.INACTIVE_REGISTERED_BUYER,
					},
				],
			},
			{
				title: 'Kyc History',
				module_slug: [
					KYC_HISTORY.MOBILE_HISTORY,
					KYC_HISTORY.NAME_HISTORY,
					KYC_HISTORY.EMAIL_HISTORY,
					KYC_HISTORY.BANK_HISTORY,
					KYC_HISTORY.PAN_HISTORY,
					KYC_HISTORY.ADDRESS_HISTORY,
					KYC_HISTORY.IMAGE_HISTORY,
				],
				icon: 'history',
				subMenu: [
					{
						title: 'Mobile History',
						path: Paths.mobileHistory,
						module_slug: KYC_HISTORY.MOBILE_HISTORY,
					},
					{
						title: 'Name History',
						path: Paths.nameHistory,
						module_slug: KYC_HISTORY.NAME_HISTORY,
					},
					{
						title: 'Email History',
						path: Paths.emailHistory,
						module_slug: KYC_HISTORY.EMAIL_HISTORY,
					},
					{
						title: 'Bank / PAN History',
						path: Paths.bankHistory,
						module_slug: KYC_HISTORY.BANK_HISTORY,
					},
					// {
					//   title: "Pan History",
					//   path: Paths.panHistory,
					//   module_slug: KYC_HISTORY.PAN_HISTORY
					// },
					{
						title: 'Address History',
						path: Paths.addressHistory,
						module_slug: KYC_HISTORY.ADDRESS_HISTORY,
					},
					{
						title: 'AB Image History',
						path: KycAdminPaths.imageHistory,
						module_slug: KYC_HISTORY.IMAGE_HISTORY,
					},
				],
			},
			{
				title: 'Bulk Operations',
				module_slug: [
					BULK_OPERATIONS.KYC_BANK_ACCOUNT,
					BULK_OPERATIONS.KYC_PAN_NUMBER,
					KYC_ACCOUNTS.PAYMENT_ENTRY,
					KYC_ACCOUNTS.BUSINESS_ENTRY,
					KYC_ACCOUNTS.JV_ENTRY,
				],
				icon: 'bulkOperations',
				subMenu: [
					{
						title: 'Bank Account',
						path: KycAdminPaths.bankAccount,
						module_slug: BULK_OPERATIONS.KYC_BANK_ACCOUNT,
					},
					{
						title: 'Pan Number',
						path: KycAdminPaths.panNo,
						module_slug: BULK_OPERATIONS.KYC_PAN_NUMBER,
					},
					{
						title: 'Payment Entry',
						path: KycAdminPaths.kycAccountsPayment,
						module_slug: KYC_ACCOUNTS.PAYMENT_ENTRY,
					},
					{
						title: 'Business Entry',
						path: KycAdminPaths.kycAccountsBusinessPayment,
						module_slug: KYC_ACCOUNTS.BUSINESS_ENTRY,
					},
					{
						title: 'JV Entry',
						path: KycAdminPaths.kycAccountsJv,
						module_slug: KYC_ACCOUNTS.JV_ENTRY,
					},
				],
			},

			{
				title: 'Kyc Tracks',
				module_slug: [KYC_TRACKS.KYC_MASTER_AB_DETAILS],
				icon: 'kycTrack',
				subMenu: [
					{
						title: 'Master AB Details',
						path: KycAdminPaths.masterAbDetails,
						module_slug: KYC_TRACKS.KYC_MASTER_AB_DETAILS,
					},
					{
						title: 'Termination History',
						path: Paths.terminationHistory,
						module_slug: KYC_TRACKS.TERMINATION_HISTORY,
					},
					{
						title: 'Not Ok History',
						path: Paths.notOkHistory,
						module_slug: KYC_TRACKS.NOT_OK_HISTORY,
					},
				],
			},
			{
				title: 'MIS',
				module_slug: [
					MIS.KYC_NOT_OK_REPORT,
					MIS.KYC_EXECUTIVE_PERFORMANCE_REPORT,
					MIS.KYC_MIS_DECLARATION_CHECK_REPORT,
					MIS.KYC_MIS_BANK_AND_PAN_REPORT,
					MIS.KYC_MIS_EMAIL_REPORT,
					MIS.KYC_MIS_MOBILE_REPORT,
					MIS.KYC_MIS_ID_PROOF_REPORT,
					MIS.KYC_MIS_NAME_REPORT,
					MIS.KYC_MIS_INFO_REPORT,
					MIS.KYC_MIS_DAILY_UPDATE_SUMMARY,
				],
				icon: 'mis',
				subMenu: [
					{
						title: 'Not Ok Checking',
						path: KycAdminPaths.notOkReport,
						module_slug: MIS.KYC_NOT_OK_REPORT,
					},
					{
						title: 'Executive Performance',
						path: KycAdminPaths.executivePerformanceReport,
						module_slug: MIS.KYC_EXECUTIVE_PERFORMANCE_REPORT,
					},
					{
						title: 'Executive Check',
						path: KycAdminPaths.executiveCheckReport,
						module_slug: MIS.KYC_EXECUTIVE_CHECK_REPORT,
					},
					{
						title: 'Declaration Check',
						path: KycAdminPaths.declarationCheckReport,
						module_slug: MIS.KYC_MIS_DECLARATION_CHECK_REPORT,
					},
					{
						title: 'Bank and Pan Report',
						path: KycAdminPaths.bankAndPanReport,
						module_slug: MIS.KYC_MIS_BANK_AND_PAN_REPORT,
					},
					// {
					//   title: "Email Check",
					//   path: KycAdminPaths.emailCheckReport,
					//   module_slug: MIS.KYC_MIS_EMAIL_REPORT
					// },
					{
						title: 'Mobile Check',
						path: KycAdminPaths.mobileCheckReport,
						module_slug: MIS.KYC_MIS_MOBILE_REPORT,
					},
					{
						title: 'Miscellaneous Check',
						path: KycAdminPaths.idProofCheckReport,
						module_slug: MIS.KYC_MIS_ID_PROOF_REPORT,
					},
					{
						title: 'Name Update Check',
						path: KycAdminPaths.nameUpdateCheckReport,
						module_slug: MIS.KYC_MIS_NAME_REPORT,
					},
					{
						title: 'Info Update Check',
						path: KycAdminPaths.infoUpdateCheckReport,
						module_slug: MIS.KYC_MIS_INFO_REPORT,
					},
					{
						title: 'Daily Summary Check',
						path: KycAdminPaths.dailyUpdateSummaryReport,
						module_slug: MIS.KYC_MIS_DAILY_UPDATE_SUMMARY,
					},
				],
			},
		],
	},
	{
		title: 'AB Accounting',
		module_slug: [
			ACCOUNTS.ACCOUNT_SUMMARY,
			ACCOUNTS.AB_BUSINESS_INFO,
			ACCOUNTS.COMPLETE_LEDGER,
			ACCOUNTS.AB_REMAINING_BALANCE,
			ACCOUNTS.AB_TDS_INFO,
			ACCOUNTS.AB_PAN,
			ACCOUNTS.REVERSE_PAYMENT,
			ACCOUNTS.AB_HOLDS,
			ACCOUNTS.COMMISSION_CYCLE,
			ACCOUNTS.CASH_BONUS_CYCLE,
			ACCOUNTS.BUSINESS_PROCESSING,
			ACCOUNTS.GST_BUSINESS_PROCESSING,
			ACCOUNTS.BANK_BOOK_SUMMARY,
			ACCOUNTS.BENEFICIARY_DETAILS,
			ACCOUNTS.MASTER_RCM_BANK,
			ACCOUNTS.AB_INVOICES,
			ACCOUNTS.UPLOAD_JOBS,
			ACCOUNTS.HDFC_STATEMENT_UPLOAD,
			ACCOUNTS.AB_LOAN_MANAGER,
			ACCOUNTS.ACCOUNTING_SAP_TDS,
		],
		icon: 'finance-icon',
		subMenu: [
			{
				title: 'AB Ledger',
				icon: 'finance-icon',
				module_slug: [ACCOUNTS.ACCOUNT_SUMMARY, ACCOUNTS.AB_REMAINING_BALANCE, ACCOUNTS.COMPLETE_LEDGER],
				subMenu: [
					{
						title: 'Account Summary',
						path: Paths.accountSummary,
						module_slug: ACCOUNTS.ACCOUNT_SUMMARY,
					},
					{
						title: 'AB Remaining Balance',
						path: Paths.abRemainingBalance,
						module_slug: ACCOUNTS.AB_REMAINING_BALANCE,
					},
					{
						title: 'Complete Ledger',
						path: Paths.completeLedger,
						module_slug: ACCOUNTS.COMPLETE_LEDGER,
					},
				],
			},
			{
				title: 'AB Business Info',
				path: Paths.abBusinessInfo,
				module_slug: ACCOUNTS.AB_BUSINESS_INFO,
			},
			{
				title: 'AB TDS Info',
				path: Paths.abTdsTracker,
				module_slug: ACCOUNTS.AB_TDS_INFO,
			},
			{
				title: 'AB PAN',
				path: Paths.panCases,
				module_slug: ACCOUNTS.AB_PAN,
			},
			{
				title: 'AB Holds',
				path: Paths.abHolds,
				module_slug: ACCOUNTS.AB_HOLDS,
			},
			{
				title: 'AB Loan Manager',
				path: Paths.abLoanManager,
				module_slug: ACCOUNTS.AB_LOAN_MANAGER,
			},
			{
				title: 'Commission Cycle',
				path: Paths.commissionCycle,
				module_slug: ACCOUNTS.COMMISSION_CYCLE,
			},
			{
				title: 'Cash Bonus Cycle',
				path: Paths.cashBonusCycle,
				module_slug: ACCOUNTS.CASH_BONUS_CYCLE,
			},
			{
				title: 'Business Processing',
				path: Paths.businessProcessing,
				module_slug: ACCOUNTS.BUSINESS_PROCESSING,
			},
			{
				title: 'GST Business Processing',
				path: Paths.gstBusinessProcessing,
				module_slug: ACCOUNTS.GST_BUSINESS_PROCESSING,
			},
			{
				title: 'Beneficiary Details',
				path: Paths.beneficiaryDetails,
				module_slug: ACCOUNTS.BENEFICIARY_DETAILS,
			},
			{
				title: 'Bank Book',
				path: Paths.bankBookSummary,
				module_slug: ACCOUNTS.BANK_BOOK_SUMMARY,
			},
			{
				title: 'AB Invoices',
				path: Paths.abInvoices,
				module_slug: ACCOUNTS.AB_INVOICES,
			},
			{
				title: 'Export Jobs',
				path: Paths.exportJobs,
				icon: 'bulkOperations',
				module_slug: ACCOUNTS.EXPORT_JOBS,
			},
			{
				title: 'Upload Jobs',
				icon: 'bulkOperations',
				module_slug: [ACCOUNTS.HDFC_STATEMENT_UPLOAD, ACCOUNTS.HDFC_RESPONSE_UPLOAD],
				subMenu: [
					{
						title: 'HDFC Statement Upload',
						path: Paths.hdfcStatementList,
						module_slug: ACCOUNTS.HDFC_STATEMENT_UPLOAD,
					},
					{
						title: 'HDFC Response Upload',
						path: Paths.hdfcResponseUpload,
						module_slug: ACCOUNTS.HDFC_RESPONSE_UPLOAD,
					},
				],
			},

			{
				title: 'Master',
				icon: 'bulkOperations',
				module_slug: [ACCOUNTS.MASTER_RCM_BANK, ACCOUNTS.MASTER_BUSINESS_REMARK],
				subMenu: [
					{
						title: 'Master RCM Bank',
						path: Paths.masterRcmBank,
						module_slug: ACCOUNTS.MASTER_RCM_BANK,
					},
					{
						title: 'Master Business Remark',
						path: Paths.masterBusinessRemark,
						module_slug: ACCOUNTS.MASTER_BUSINESS_REMARK,
					},
				],
			},
			{
				title: 'SAP',
				icon: 'bulkOperations',
				module_slug: [ACCOUNTS.SAP_BUSINESS, ACCOUNTS.SAP_PAYMENT, ACCOUNTS.ACCOUNTING_SAP_TDS],
				subMenu: [
					{
						title: 'Business',
						path: Paths.sapBusinessReport,
						module_slug: ACCOUNTS.SAP_BUSINESS,
					},
					{
						title: 'Payment',
						path: Paths.sapPaymentReport,
						module_slug: ACCOUNTS.SAP_PAYMENT,
					},
					{
						title: 'TDS Report',
						path: Paths.sapTdsReport,
						module_slug: ACCOUNTS.ACCOUNTING_SAP_TDS,
					},
				],
			},
		],
	},
	{
		title: 'Utility',
		module_slug: [UTILITY.SCHEDULE_MANAGEMENT, UTILITY.MANAGE_AB_LOGIN, 'remarks_master'],
		icon: '',
		subMenu: [
			// {
			//   title: "Bulk Update PV",
			//   path: Paths.bulkUploadPv,
			//   module_slug: "manage_utility"
			// },
			{
				title: 'Ecom AB Login',
				path: Paths.ecomABLogin,
				module_slug: UTILITY.MANAGE_AB_LOGIN,
			},
			{
				title: 'Schedule Management',
				path: Paths.scheduleManagement,
				module_slug: UTILITY.SCHEDULE_MANAGEMENT,
			},
		],
	},
	{
		title: 'Business',
		module_slug: [
			BUSINESS_MODULES.CONSISTENCY_DATA,
			BUSINESS_MODULES.CASH_BONUS_DATA,
			BUSINESS_MODULES.FINAL_CASH_BONUS,
			BUSINESS_MODULES.FINAL_RCM_CONSISTENCY,
		],
		icon: 'barChart',
		subMenu: [
			{
				title: 'Consistency Data',
				path: Paths.consistencyData,
				module_slug: BUSINESS_MODULES.CONSISTENCY_DATA,
			},
			{
				title: 'Cash Bonus Data',
				path: Paths.cashBonusData,
				module_slug: BUSINESS_MODULES.CASH_BONUS_DATA,
			},
			{
				title: 'Final Cash Bonus',
				module_slug: BUSINESS_MODULES.FINAL_CASH_BONUS,
				path: Paths.finalCashBonus,
			},
			{
				title: 'Final RCM Consistency',
				module_slug: BUSINESS_MODULES.FINAL_RCM_CONSISTENCY,
				path: Paths.finalRcmConsistency,
			},
		],
	},
	{
		title: 'Zonal',
		module_slug: ['zonal_sales_user', 'zonal_observation'],
		icon: 'global',
		subMenu: [
			{
				title: 'Sales User',
				module_slug: 'zonal_sales_user',
				path: Paths.zonalSalesUser,
			},
			{
				title: 'Observation Checklist',
				module_slug: 'zonal_observation',
				path: Paths.zonalObservation,
			},
		],
	},
	{
		title: 'Genie',
		module_slug: Object.values(GENIE),
		icon: 'genie',
		subMenu: [
			{
				title: 'Masters',
				module_slug: [
					GENIE.GENIE_MASTER_COMPANY_TARGET,
					GENIE.GENIE_MASTER_ACTIVITY_TARGETS,
					GENIE.GENIE_MASTER_GMV,
				],
				icon: 'no',
				subMenu: [
					{
						title: 'Company Target',
						path: Paths.genieCompanyTarget,
						module_slug: GENIE.GENIE_MASTER_COMPANY_TARGET,
					},
					{
						title: 'Activities',
						path: Paths.genieActivity,
						module_slug: GENIE.GENIE_MASTER_ACTIVITY,
					},
					{
						title: 'Activity Target',
						path: Paths.genieActivityTarget,
						module_slug: GENIE.GENIE_MASTER_ACTIVITY_TARGETS,
					},
					{
						title: 'GMV',
						path: Paths.genieGmv,
						module_slug: GENIE.GENIE_MASTER_GMV,
					},
					{
						title: 'Skill Development',
						path: Paths.genieSkillDevelopment,
						module_slug: GENIE.GENIE_MASTER_SKILL_DEVELOPMENT_TARGETS,
					},
				],
			},
			{
				title: 'Target Report',
				path: Paths.genieTargetReport,
				module_slug: GENIE.GENIE_TARGET_REPORT,
				icon: 'no',
			},
			{
				title: 'Achievement Report',
				path: Paths.genieAchievementReport,
				module_slug: GENIE.GENIE_ACHIEVEMENT_REPORT,
				icon: 'no',
			},
			{
				title: 'Review & Approval',
				path: Paths.genieReviewAndApproval,
				module_slug: GENIE.GENIE_REVIEW_AND_APPROVAL,
				icon: 'no',
			},
			{
				title: 'Pillar Mapping',
				path: Paths.geniePillarMapping,
				module_slug: GENIE.GENIE_MASTER_PILLAR_MAPPING,
				icon: 'no',
			},

			{
				title: 'Configurations',
				module_slug: [GENIE.GENIE_SETTINGS],
				icon: 'no',
				subMenu: [
					{
						title: 'Setting',
						path: Paths.genieSettings,
						module_slug: GENIE.GENIE_SETTINGS,
					},
				],
			},
		],
	},
	{
		// Parent shows in sidebar if user has ANY of the 4 post sub-permissions.
		// Each sub-item gates on its own slug — backend matches on the same slug
		// via moduleGuard per route group.
		title: 'Post',
		module_slug: ['post_entries', 'post_dashboard', 'post_report', 'post_couriers'],
		icon: 'mail',
		subMenu: [
			{
				title: 'Entries',
				module_slug: 'post_entries',
				path: Paths.postList,
			},
			{
				title: 'Dashboard',
				module_slug: 'post_dashboard',
				path: Paths.postDashboard,
			},
			{
				title: 'Report',
				module_slug: 'post_report',
				path: Paths.postReport,
			},
			{
				title: 'Couriers',
				module_slug: 'post_couriers',
				path: Paths.postCouriers,
			},
		],
	},
	{
		// Parent shows if user has ANY of qr_generator or sto_app_access — the
		// STO Loading History sub-item is gated independently on sto_app_access
		// so a user with only that permission still sees the parent + that item.
		title: 'Generate QR Code',
		module_slug: ['qr_generator', 'sto_app_access'],
		icon: 'qr',
		subMenu: [
			{
				title: 'Generate',
				module_slug: 'qr_generator',
				path: Paths.qrGenerator,
			},
			{
				title: 'History',
				module_slug: 'qr_generator',
				path: Paths.qrGeneratorHistory,
			},
			{
				title: 'STO Loading History',
				module_slug: 'sto_app_access',
				path: Paths.stoLoadingHistory,
			},
			{
				title: 'STO Allowed Products',
				module_slug: 'sto_app_access',
				path: Paths.stoAllowedProducts,
			},
		],
	},
	{
		title: 'Consistency Calculator',
		module_slug: 'consistency_calculator',
		icon: 'calculator',
		subMenu: [
			{
				title: 'What-if Calculator',
				module_slug: 'consistency_calculator',
				path: Paths.consistencyCalculator,
			},
			{
				title: 'Upload Batch',
				module_slug: 'consistency_calculator',
				path: Paths.consistencyUpload,
			},
			{
				title: 'Saved Batches',
				module_slug: 'consistency_calculator',
				path: Paths.consistencyPeriods,
			},
		],
	},
	{
		title: 'Cash Bonus',
		module_slug: 'cash_bonus',
		icon: 'wallet',
		subMenu: [
			{
				title: 'What-if Calculator',
				module_slug: 'cash_bonus',
				path: Paths.cashBonusCalculator,
			},
			{
				title: 'Upload Batch',
				module_slug: 'cash_bonus',
				path: Paths.cashBonusUpload,
			},
			{
				title: 'Saved Batches',
				module_slug: 'cash_bonus',
				path: Paths.cashBonusPeriods,
			},
		],
	},
	{
		title: 'Sehat Mitra Course',
		module_slug: ['manage_sehat_mitra_course_batch', 'manage_sehat_mitra_course_report'],
		subMenu: [
			{
				title: 'Manage Batches',
				path: Paths.manageSehatMitraCourseBatch,
				module_slug: 'manage_sehat_mitra_course_batch',
			},
			{
				title: 'Registration Report',
				path: Paths.manageSehatMitraCourseReport,
				module_slug: 'manage_sehat_mitra_course_report',
			},
		],
	},
	{
		title: 'Drive Management',
		module_slug: Object.values(DRIVE_MODULE),
		icon: 'genie',
		subMenu: [
			{
				title: 'Targets',
				module_slug: [DRIVE_MODULE.DRIVE_REVENUE_TARGET],
				icon: 'no',
				subMenu: [
					{
						title: 'Revenue target',
						path: Paths.driveRevenueTarget,
						module_slug: DRIVE_MODULE.DRIVE_REVENUE_TARGET,
					},
					{
						title: 'Repurchaser target',
						path: Paths.driveRepurchaserTargetList,
						module_slug: DRIVE_MODULE.DRIVE_REPURCHASER_TARGET,
					},
				],
			},
			{
				title: 'Reports',
				module_slug: [
					DRIVE_MODULE.DRIVE_REVENUE_REPORT,
					DRIVE_MODULE.DRIVE_REACTIVATION_REPORT,
					DRIVE_MODULE.DRIVE_REPURCHASER_REPORT,
				],
				icon: 'no',
				subMenu: [
					{
						title: 'Revenue report',
						path: Paths.driveRevenueReport,
						module_slug: DRIVE_MODULE.DRIVE_REVENUE_REPORT,
					},
					{
						title: 'Reactivation report',
						path: Paths.driveReactivationReport,
						module_slug: DRIVE_MODULE.DRIVE_REACTIVATION_REPORT,
					},
					{
						title: 'KYC MIS report',
						path: Paths.driveMISReport,
						module_slug: DRIVE_MODULE.DRIVE_MIS_REPORT,
					},
					{
						title: 'Repurchaser report',
						path: Paths.driveRepurchaserReport,
						module_slug: DRIVE_MODULE.DRIVE_REPURCHASER_REPORT,
					},
				],
			},
		],
	},
	{
		title: 'Gooddot Rasoi',
		module_slug: ['manage_gooddot_rasoi_batch', 'manage_gooddot_rasoi_applications', 'manage_gooddot_rasoi_report'],
		subMenu: [
			{
				title: 'Manage Batches',
				path: Paths.manageGooddotRasoiBatch,
				module_slug: 'manage_gooddot_rasoi_batch',
			},
			{
				title: 'Manage Applications',
				path: Paths.manageGooddotRasoiApplications,
				module_slug: 'manage_gooddot_rasoi_applications',
			},
			{
				title: 'Reports',
				module_slug: ['manage_gooddot_rasoi_report'],
				icon: 'reports',
				subMenu: [
					{
						title: 'Gooddot Rasoi Report',
						path: Paths.gooddotRasoiReport,
						module_slug: 'manage_gooddot_rasoi_report',
					},
				],
			},
		],
	},
];

// create search menus
export const createSearchMenus = (menusArray, parentKey = '') => {
	return menusArray.reduce((acc, curr) => {
		// for submenus
		if (curr?.subMenu?.length > 0) {
			acc = [
				...acc,
				...createSearchMenus(curr?.subMenu, parentKey ? `${parentKey} > ${curr.title}` : curr.title),
			];
		}

		// for single
		else {
			parentKey
				? acc.push({
						label: `${parentKey} > ${curr.title}`,
						value: curr.path,
					})
				: acc.push({
						label: curr.title,
						value: curr.path,
					});
		}

		return acc;
	}, []);
};
